import { Link } from 'react-router-dom'

type ButtonVariant = 'primary' | 'secondary' | 'ghost'

interface ButtonProps {
  children: React.ReactNode
  variant?: ButtonVariant
  to?: string
  href?: string
  onClick?: () => void
  type?: 'button' | 'submit'
  disabled?: boolean
  className?: string
  fullWidth?: boolean
}

const variantClasses: Record<ButtonVariant, string> = {
  primary: 'btn-primary',
  secondary: 'btn-ghost',
  ghost: 'btn-ghost',
}

export function Button({
  children,
  variant = 'primary',
  to,
  href,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  fullWidth = false,
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center gap-2 border-0 cursor-pointer no-underline'
  const variantClass = variantClasses[variant]
  const widthClass = fullWidth ? 'w-full' : ''
  const combinedClass = `${baseClasses} ${variantClass} ${widthClass} ${className}`.trim()

  if (to) {
    return (
      <Link to={to} className={combinedClass}>
        {children}
      </Link>
    )
  }
  if (href) {
    return (
      <a href={href} className={combinedClass} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    )
  }
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={combinedClass}
    >
      {children}
    </button>
  )
}
